// const genRoutes = routes.map((rt) => {
//   rt
// });

// export const general_routes = (_prefix, _section) => {
// var _pref = _prefix ? _prefix : "";

// var section = _section && _section.section ? _section.section + "/" : "";

/*
  var routes = [
    {
      path: `/${section}error`,
      name: `${_pref}error`,
      component: () => import("@/views/pages/error/Error.vue"),
      meta: {
        ..._section
      },
      children: [
        {
          path: `${section}error-1`,
          name: `${_pref}error-1`,
          meta: {
            ..._section
          },
          component: () => import("@/views/pages/error/Error-1.vue")
        },
        {
          path: `${section}error-2`,
          name: `${_pref}error-2`,
          meta: {
            ..._section
          },
          component: () => import("@/views/pages/error/Error-2.vue")
        },
        {
          path: `${section}error-3`,
          name: `${_pref}error-3`,
          meta: {
            ..._section
          },
          component: () => import("@/views/pages/error/Error-3.vue")
        },
        {
          path: `${section}error-4`,
          name: `${_pref}error-4`,
          meta: {
            ..._section
          },
          component: () => import("@/views/pages/error/Error-4.vue")
        },
        {
          path: `${section}error-5`,
          name: `${_pref}error-5`,
          meta: {
            ..._section
          },
          component: () => import("@/views/pages/error/Error-5.vue")
        },
        {
          path: `${section}error-6`,
          name: `${_pref}error-6`,
          meta: {
            ..._section
          },
          component: () => import("@/views/pages/error/Error-6.vue")
        }
      ]
    },
    // {
    //   path: `/${section}*`,
    //   redirect: `/${section}404`
    // },
    {
      // the 404 route, when none of the above matches
      path: `/${section}404`,
      name: `${_pref}404`,
      meta: {
        ..._section
      },
      component: () => import("@/views/pages/error/Error-1.vue")
    }
  ];
  */

var routes = [
  {
    path: "/admin/*",
    redirect: "/admin/not-found"
  },
  {
    path: "*",
    redirect: "/404"
  }
  // {
  //   path: "/affiliates/404",
  //   name: "affiliate-404",
  //   meta: {
  //     section: "affiliate"
  //   },
  //   component: () => import("@/views/pages/error/Error-1.vue")
  // },
  // {
  //   path: "/vendors/404",
  //   name: "vendor-404",
  //   meta: {
  //     section: "vendor"
  //   },
  //   component: () => import("@/views/pages/error/Error-1.vue")
  // }
];

// console.log(routes);

//   return routes;
// };

export const general_routes = routes;
